import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import Chart from 'chart.js/auto';
import React from 'react';

import 'chartjs-adapter-luxon';
import Section from 'components/common/Section';
import DIRECTION_VERTICAL from 'constants/DIRECTION_VERTICAL';
import { numberWithComma } from 'utils/number';

import ExerciseAnalysisChart from '../../../charts/ExerciseAnalysisChart';
import EXERCISE_COLUMNS from 'constants/EXERCISE_COLUMNS';
import CHECK_COLORS from 'constants/CHECK_COLORS';

export default function ExerciseAnalysis(props) {
  const {
    viewMode,
    stepData,
    caloryData,
    duration,
    ...rest
  } = props || {};

  const stepList = React.useMemo(() => {
    const {
      active_analyze_day_list = [],
      active_analyze_week_days_weekend_list = [],
    } = stepData || {};

    const list = [];
    active_analyze_day_list?.forEach((data, index) => {
      const {
        day_tp_cd,
        avg_step_cnt,
        avg_active_time,
        avg_bld_sugr,
      } = data;
      // list[0].avg_step_cnt += +avg_step_cnt;
      // list[0].avg_active_time += +avg_active_time;
      // list[0].avg_bld_sugr += +avg_bld_sugr;

      list.push({
        avg_step_cnt,
        avg_active_time,
        avg_bld_sugr,
      });
      // list[+day_tp_cd].avg_step_cnt = avg_step_cnt;
      // list[+day_tp_cd].avg_active_time = avg_active_time;
      // list[+day_tp_cd].avg_bld_sugr = avg_bld_sugr;
    });

    // 평균값
    // list[0].avg_step_cnt = (+list[0].avg_step_cnt / 7).toFixed(0);
    // list[0].avg_active_time = (+list[0].avg_active_time / 7).toFixed(0);
    // list[0].avg_bld_sugr = (+list[0].avg_bld_sugr / 7).toFixed(0);

    active_analyze_week_days_weekend_list?.forEach((data, index) => {
      const {
        week_days_weekend_tp_cd,
        avg_step_cnt,
        avg_active_time,
        avg_bld_sugr,
      } = data;
      list.push({
        avg_step_cnt,
        avg_active_time,
        avg_bld_sugr,
      })
    });
    return list;
  }, [stepData]);


  const caloryList = React.useMemo(() => {
    const {
      active_analyze_day_list = [],
      active_analyze_week_days_weekend_list = [],
    } = caloryData || {};

    const list = [];
    active_analyze_day_list?.forEach((data, index) => {
      const {
        day_tp_cd,
        avg_cal_amt,
        avg_active_time,
        avg_bld_sugr,
      } = data;
      list.push({
        avg_cal_amt,
        avg_active_time,
        avg_bld_sugr,
      })
    });

    active_analyze_week_days_weekend_list?.forEach((data, index) => {
      const {
        week_days_weekend_tp_cd,
        avg_cal_amt,
        avg_active_time,
        avg_bld_sugr,
      } = data;
      list.push({
        avg_cal_amt,
        avg_active_time,
        avg_bld_sugr,
      })
    });
    return list;
  }, [caloryData]);

  return (
    <Section
      {...ex(['ExerciseAnalysis', viewMode], rest)}
      {...{
        caption: T('활동분석 (week)'),
        direction: DIRECTION_VERTICAL,
      }}
    >
      <div>
        <ExerciseAnalysisChart {...props} />
        <div>
          <div {...ex('ExerciseAnalysisLegend')}>
            <div></div>
            <div>
              {viewMode === 'ReportExerciseSteps' && T('걸음수 (5,000보 이상이면 100% 표시)')}
              {viewMode === 'ReportExerciseCalories' && T('소모칼로리 (200kcal 이상이면 100% 표시)')}
            </div>
          </div>
          <div {...ex('ExerciseAnalysisLegend')}>
            <div></div>
            <div>
              {T('평균혈당 (250mg/dL 이상이면 100% 표시)')}
            </div>
          </div>
        </div>
      </div>
      <table>
        <thead>
          <tr>
            {EXERCISE_COLUMNS.map(text => (
              <th key={text}>
                <div>
                  {text}
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div>
                {viewMode === 'ReportExerciseSteps' && T('평균 걸음수 (보)')}
                {viewMode === 'ReportExerciseCalories' && T('평균 소모칼로리 (kcal)')}
              </div>
            </td>
            {viewMode === 'ReportExerciseSteps' && stepList.map((data, index) => {
              return (
                <td key={index}>
                  <div>
                    {numberWithComma(data.avg_step_cnt)}
                  </div>
                </td>
              );
            })}
            {viewMode === 'ReportExerciseCalories' && caloryList.map((data, index) => {
              return (
                <td key={index}>
                  <div>
                    {numberWithComma(data.avg_cal_amt)}
                  </div>
                </td>
              );
            })}
          </tr>
          <tr>
            <td>
              <div>
                {T('평균 활동시간 (분)')}
              </div>
            </td>
            {viewMode === 'ReportExerciseSteps' && stepList.map((data, index) => {
              return (
                <td key={index}>
                  <div>
                    {numberWithComma(data.avg_active_time)}
                  </div>
                </td>
              );
            })}
            {viewMode === 'ReportExerciseCalories' && caloryList.map((data, index) => {
              return (
                <td key={index}>
                  <div>
                    {numberWithComma(data.avg_active_time)}
                  </div>
                </td>
              );
            })}
          </tr>
          <tr>
            <td>
              <div>
                {T('평균혈당 (mg/dL)')}
              </div>
            </td>
            {viewMode === 'ReportExerciseSteps' && stepList.map((data, index) => {
              return (
                <td key={index}>
                  <div {...ex(['BASE_COLOR', CHECK_COLORS('B', data.avg_bld_sugr)])}>
                    {numberWithComma(data.avg_bld_sugr)}
                  </div>
                </td>
              );
            })}
            {viewMode === 'ReportExerciseCalories' && caloryList.map((data, index) => {
              return (
                <td key={index}>
                  <div {...ex(['BASE_COLOR', CHECK_COLORS('B', data.avg_bld_sugr)])}>
                    {numberWithComma(data.avg_bld_sugr)}
                  </div>
                </td>
              );
            })}
          </tr>
        </tbody>
      </table>
    </Section>
  );
}
